import React from 'react';
import InputMask from 'react-input-mask';

const inputPhoneField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <div className={`form-group ${touched && error ? 'has-error' : ''}`}>
    <label>{label}</label>
     <InputMask className="form-control" {...input} mask="+1 (999) 999-9999" maskChar={null} />
    {(touched && error) && <label id={`${input.name}-error`} className="error" htmlFor={input.name}>{error}</label>}
  </div>
);

export default inputPhoneField;



// WEBPACK FOOTER //
// ./src/components/RequestForm/InputPhoneField.js